<template>
  <v-card
    tile
    flat
    width="100%"
    class="fill-height"
    :color="state === 0 ? 'primary' : 'white'"
    v-if="data"
  >
    <div class="fill-height appcomenta">
      <div class="fill-height">
        <v-app-bar
          elevate-on-scroll
          app
          color="white"
          v-if="state === 1 || state === 2"
          max-width="600px"
          class="mx-auto"
        >
          <v-container fluid>
            <div>
              <br />
              <Barra :zoom="calcComplete" v-if="state === 1" />
              <Barra :zoom="zoom" v-if="state === 2" />
            </div>
          </v-container>
        </v-app-bar>

        <v-card
          v-if="state === 0 && loading === true"
          tile
          flat
          dark
          color="primary"
          max-width="600px"
          class="fill-height"
        >
          <v-img src="@/assets/splash.png" width="100%" height="100%">
            <v-row align="center" justify="center" class="fill-height ma-0">
              <v-col class="text-center">
                <img src="@/assets/splash/Group.png" class="img-logo" />
              </v-col>
            </v-row>
          </v-img>
        </v-card>

        <v-main class="fill-height full-width" v-if="data.store_data">
          <v-card
            tile
            flat
            dark
            color="primary"
            width="100%"
            class="fill-height"
            v-if="state === 0 && loading === false && data"
            @click="state = 1"
          >
            <BemVindo
              :img="store.icon"
              :imgSize="store.image_size.toString()"
              :clientName="this.queryString.clientName"
              :loja="data.store_data.name"
              :text="text.bemvindo"
            />
          </v-card>

          <v-card
            tile
            flat
            width="100%"
            class="fill-height pa-5"
            v-if="state === 1"
          >
            <v-container fluid class="fill-height">
              <div v-if="ordenator.length > 0">
                <div v-for="ordem in ordenator" :key="ordem">
                  <div
                    v-for="(customQuestion,
                    i) in store.perguntas_personalizadas"
                    :key="i"
                  >
                    <div
                      v-if="ordem === 't' + customQuestion.id"
                      style="width: 100%"
                    >
                      <div
                        class="mt-5"
                        style="width: 100%"
                        v-if="store.perguntas_personalizadas"
                      >
                        {{ customQuestion.pergunta }}
                        <sup
                          v-if="customQuestion.optional === 0"
                          class="caption"
                          >*</sup
                        ><br />
                        <v-textarea
                          outlined
                          class="my-2"
                          v-model="resposta_personalizadas[i]"
                        ></v-textarea>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="(optionGroup, i) in selectors"
                    :key="'optiongroup_' + optionGroup.id"
                  >
                    <div
                      v-if="
                        optionGroup.options.length > 0 &&
                          ordem === 's' + optionGroup.id
                      "
                      class="mb-5 fill-width"
                      style="width: 100%"
                    >
                      <v-switch
                        v-if="inArray(optionGroup.id, optionals.options)"
                        v-model="questionEnable[i]"
                        inset
                        :label="`Selecionar ${optionGroup.title.toString()}`"
                      ></v-switch>
                      <div
                        v-if="
                          questionEnable[i] ||
                            !inArray(optionGroup.id, optionals.options)
                        "
                      >
                        <EmojiTitle
                          :title="optionGroup.title"
                          :isSelected="selected[i]"
                          :emoji="selected[i]"
                          :chave="1"
                          :actual="1"
                        />
                        <div v-if="!inArray(optionGroup.id, optionals.options)">
                          <div v-if="optionGroup.select=='1'">
                            <v-autocomplete
                              :placeholder="`Selecione uma opção`"
                              v-model="selected[i]"
                              :items="optionGroup.options"
                              item-text="title"
                              item-value="id"
                            ></v-autocomplete>
                          </div>
                          <div v-if="optionGroup.multiple=='1'">
                              <v-chip
                              v-for="(item, i) in optionGroup.options"
                              :key="i"
                              label
                              :outlined="getColor(item) === 'gray'"
                              :color="getColor(item)"
                              class="ma-2"
                              @click="addMotive(item,optionGroup.id)"
                            >
                              {{ item.title }}
                            </v-chip>
                          </div>
                          <div v-if="optionGroup.select=='0' && optionGroup.multiple=='0' ">
                            <v-radio-group v-model="selected[i]" row>
                              <v-radio
                                v-for="option in optionGroup.options"
                                :key="'option_' + option.id"
                                :label="option.title"
                                :value="option.id"
                              ></v-radio>
                            </v-radio-group>
                            <div
                              v-for="option in optionGroup.options"
                              :key="option.id"
                            ></div>
                          </div>
                        </div>
                        <div v-if="inArray(optionGroup.id, optionals.options)">
                          <v-radio-group
                            v-model="selectedButNotAccounted[optionGroup.id]"
                            row
                          >
                            <v-radio
                              v-for="option in optionGroup.options"
                              :key="'option_' + option.id"
                              :label="option.title"
                              :value="option.id"
                            ></v-radio>
                          </v-radio-group>
                          <div
                            v-for="option in optionGroup.options"
                            :key="option.id"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-for="(item, i) in categories"
                    :key="item.id"
                    class="mb-5 fill-width"
                    style="width: 100%"
                  >
                    <div
                      v-if="
                        typeof item.id !== 'undefined' &&
                          ordem === 'q' + item.id
                      "
                      :key="item.id"
                      class="mb-5 fill-width"
                      style="width: 100%"
                    >
                      <v-switch
                        v-if="
                          item.optional == 1 ||
                            inArray(item.id, optionals.questions)
                        "
                        v-model="emojiEnabled[i]"
                        inset
                        :label="`Avaliar ${item.title.toString()}`"
                      ></v-switch>
                      <div
                        v-if="
                          item.title !== '' &&
                            (emojiEnabled[i] ||
                              (item.optional == 0 &&
                                !inArray(item.id, optionals.questions)))
                        "
                      >
                        <EmojiTitle
                          :isenabled="emojiEnabled[i]"
                          :title="item.title"
                          :isSelected="emojis[i]"
                          :emoji="emojis[i]"
                          :chave="1"
                          :actual="1"
                        />
                        <Emojis
                          v-if="!emojiEnabled[i]"
                          :issecondary="false"
                          v-model="emojis[i]"
                          :color="color"
                          :id="item.id"
                          :zoom="
                            item.optional == 0 &&
                            !inArray(item.id, optionals.questions)
                              ? calcComplete
                              : null
                          "
                          :chave="1"
                          :actual="1"
                          :questions="item.subquestions"
                        />
                        <Emojis
                          v-if="emojiEnabled[i]"
                          :issecondary="true"
                          v-model="optemojis[i]"
                          :color="color"
                          :id="item.id"
                          :chave="1"
                          :actual="1"
                          :questions="item.subquestions"
                        />
                        <div v-if="item.id == 1 && emojis.length > 0">
                          <div class="mt-5" style="width: 100%">
                            <v-switch
                              v-model="atendente"
                              inset
                              :label="
                                `Desejo informar o meu ${atendant_denomination}`
                              "
                            ></v-switch>

                            <div v-if="atendente">
                              <b>
                                {{
                                  atendant_denomination
                                    .charAt(0)
                                    .toUpperCase() +
                                    atendant_denomination.slice(1)
                                }}
                                <sup class="caption">*</sup></b
                              >
                              <br />
                              <v-autocomplete
                                :placeholder="
                                  atendant_denomination
                                    .charAt(0)
                                    .toUpperCase() +
                                    atendant_denomination.slice(1)
                                "
                                v-model="form.attendant_id"
                                v-if="
                                  store.atendentes &&
                                    store.atendentes.length > 0
                                "
                                :items="store.atendentes"
                                item-text="nome"
                                item-value="id"
                              >
                                <template v-slot:selection="data">
                                  <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                  >
                                    <v-avatar v-if="!!data.item.avatar" left>
                                      <v-img
                                        :src="
                                          'https://s3.us-west-2.amazonaws.com/beniapp/storage/' +
                                            data.item.avatar
                                        "
                                      ></v-img>
                                    </v-avatar>
                                    {{ data.item.nome }}
                                  </v-chip>
                                </template>
                                <template v-slot:item="data">
                                  <template v-if="!isObject(data.item)">
                                    <v-list-item-content
                                      v-text="data.item"
                                    ></v-list-item-content>
                                  </template>
                                  <template v-else>
                                    <v-list-item-avatar
                                      v-if="!!data.item.avatar"
                                    >
                                      <img
                                        :src="
                                          'https://s3.us-west-2.amazonaws.com/beniapp/storage/' +
                                            data.item.avatar
                                        "
                                      />
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-html="data.item.nome"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </template>
                                </template>
                              </v-autocomplete>
                              <v-text-field
                                class="my-2"
                                :placeholder="
                                  atendant_denomination
                                    .charAt(0)
                                    .toUpperCase() +
                                    atendant_denomination.slice(1)
                                "
                                v-model="form.attendant"
                                v-if="
                                  !store.atendentes ||
                                    store.atendentes.length === 0
                                "
                              ></v-text-field>

                              <div
                                v-if="form.attendant_id || form.attendant"
                                class="my-5"
                              >
                                <Emojis2
                                  :color="color"
                                  v-model="form.attendant_eval"
                                />
                              </div>

                              Deseja adicionar algum comentário referente ao
                              {{ atendant_denomination }}? <br />
                              <v-textarea
                                class="my-2"
                                outlined
                                v-model="form.attendant_obs"
                              ></v-textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="ordenator.length < 1">
                <div
                  v-for="(item, i) in selectors"
                  :key="'optiongroup_' + item.id"
                >
                  <div
                    v-if="item.options.length > 0"
                    class="mb-5 fill-width"
                    style="width: 100%"
                  >
                    <EmojiTitle
                      :title="item.title"
                      :isSelected="selected[i]"
                      :chave="1"
                      :actual="1"
                    />
                    <v-radio-group v-model="selected[i]" row>
                      <v-radio
                        v-for="option in item.options"
                        :key="'option_' + option.id"
                        :label="option.title"
                        :value="option.id"
                      ></v-radio>
                    </v-radio-group>
                    <div v-for="option in item.options" :key="option.id"></div>
                  </div>
                </div>

                <div
                  v-for="(item, i) in categories"
                  :key="item.id"
                  class="mb-5 fill-width"
                  style="width: 100%"
                >
                  <div
                    v-if="typeof item.id !== 'undefined'"
                    :key="item.id"
                    class="mb-5 fill-width"
                    style="width: 100%"
                  >
                    <v-switch
                      v-if="item.optional == 1"
                      v-model="emojiEnabled[i]"
                      inset
                      :label="`Avaliar ${item.title.toString()}`"
                    ></v-switch>
                    <EmojiTitle
                      v-if="
                        item.title !== '' &&
                          (emojiEnabled[i] || item.optional == 0)
                      "
                      :isenabled="emojiEnabled[i]"
                      :title="item.title"
                      :isSelected="emojis[i]"
                      :emoji="emojis[i]"
                      :chave="1"
                      :actual="1"
                    />
                    <Emojis
                      v-if="item.optional == 0"
                      :issecondary="false"
                      v-model="emojis[i]"
                      :color="color"
                      :id="item.id"
                      :zoom="item.optional == 0 ? calcComplete : null"
                      :chave="1"
                      :actual="1"
                      :questions="item.subquestions"
                    />
                    <Emojis
                      v-if="emojiEnabled[i] && item.optional == 1"
                      :issecondary="true"
                      v-model="optemojis[i]"
                      :color="color"
                      :id="item.id"
                      :chave="1"
                      :actual="1"
                      :questions="item.subquestions"
                    />
                    <div v-if="item.id == 1 && emojis.length > 0">
                      <div class="mt-5" style="width: 100%">
                        <v-switch
                          v-model="atendente"
                          inset
                          :label="
                            `Desejo informar o meu ${atendant_denomination}`
                          "
                        ></v-switch>

                        <div v-if="atendente">
                          <b>
                            {atendant_denomination}
                            <sup class="caption">*</sup></b
                          >
                          <br />
                          <v-autocomplete
                            :placeholder="
                              atendant_denomination.charAt(0).toUpperCase() +
                                atendant_denomination.slice(1)
                            "
                            v-model="form.attendant_id"
                            v-if="
                              store.atendentes && store.atendentes.length > 0
                            "
                            :items="store.atendentes"
                            item-text="nome"
                            item-value="id"
                          ></v-autocomplete>
                          <v-text-field
                            class="my-2"
                            :placeholder="
                              atendant_denomination.charAt(0).toUpperCase() +
                                atendant_denomination.slice(1)
                            "
                            v-model="form.attendant"
                            v-if="
                              !store.atendentes || store.atendentes.length === 0
                            "
                          ></v-text-field>

                          <div
                            v-if="form.attendant_id || form.attendant"
                            class="my-5"
                          >
                            <Emojis2
                              :color="color"
                              v-model="form.attendant_eval"
                            />
                          </div>

                          Deseja adicionar algum comentário referente ao
                          {{ atendant_denomination }}? <br />
                          <v-textarea
                            class="my-2"
                            outlined
                            v-model="form.attendant_obs"
                          ></v-textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 100%">
                  <div
                    class="mt-5"
                    style="width: 100%"
                    v-if="store.perguntas_personalizadas"
                  >
                    <div
                      v-for="(item, i) in store.perguntas_personalizadas"
                      :key="i"
                    >
                      {{ item.pergunta }}
                      <sup v-if="item.optional === 0" class="caption">*</sup
                      ><br />
                      <v-textarea
                        outlined
                        class="my-2"
                        v-model="resposta_personalizadas[i]"
                      ></v-textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 100%">
                <p class="mt-5">
                  {{ text.nota | formatName(data.store_data.name) }}
                </p>
              </div>
              <div style="width: 100%;text-align:center;">
                <v-slider
                  color="primary"
                  track-color="acent"
                  thumb-color="primary"
                  thumb-label="always"
                  height="40"
                  max="10"
                  min="0"
                  :value="calcMedia"
                  class="my-10"
                  v-model="form.media"
                >
                </v-slider>
                <img
                  eager
                  style="width: 100%"
                  :src="
                    `https://comenta.ai/assets/tint.php?hex=${color.replace(
                      '#',
                      ''
                    )}&image=indicator.png`
                  "
                />
                <br />
                <br />
              </div>
              <div style="width: 100%">
                <p>
                  {{ text.comentario | formatName(data.store_data.name) }}
                </p>
              </div>
              <div style="width: 100%">
                <v-textarea outlined v-model="form.comment"></v-textarea>
              </div>

              <v-fab-transition>
                <div class="text-center" style="width: 100%">
                  <v-btn
                    rounded
                    depressed
                    :color="checkDisabled ? 'primary' : 'grey lighten-1'"
                    dark
                    large
                    class="mt-10 px-10"
                    @click="checkDisabled ? changeState(2) : (error = true)"
                  >
                    <h2><b>Enviar</b></h2>
                  </v-btn>
                  <br />
                  <div v-if="!checkDisabled && error" class="my-5 x-small-text">
                    Por favor, preencha todos os campos para avançar
                  </div>
                </div>
              </v-fab-transition>
            </v-container>
          </v-card>

          <v-card
            tile
            flat
            width="100%"
            class="fill-height pa-5"
            v-if="state === 2"
          >
            <v-container fluid class="center">
              <div style="width: 100%">
                <v-switch
                  v-if="noObligatoryField"
                  v-model="anonymously"
                  inset
                  :label="`Avaliar anonimamente`"
                ></v-switch>
                <h1
                  v-if="!anonymously"
                  class="text-center text-secondary my-10"
                >
                  <b>Preencha seus Dados</b>
                </h1>
              </div>
              <v-form
                v-if="!anonymously || !noObligatoryField"
                v-model="valid"
                ref="form"
                style="width: 100%"
              >
                <div
                  v-for="item in formFields"
                  :key="item.id"
                  class="mb-5 fill-width"
                  style="width: 100%"
                >
                  <div style="width: 100%">
                    <b>
                      {{ item.title }}
                      <sup v-if="item.mandatory === true" class="caption"
                        >*</sup
                      ></b
                    >
                  </div>

                  <div v-if="item.type === 'text'" style="width: 100%">
                    <v-text-field
                      @input="checkAllForm()"
                      :placeholder="item.title"
                      v-model="form[item.id]"
                    ></v-text-field>
                  </div>

                  <div v-if="item.type === 'phone'" style="width: 100%">
                    <v-text-field
                      @input="checkAllForm()"
                      placeholder="(51) 99999-9999"
                      v-model="form[item.id]"
                      v-mask="'(##) #####-####'"
                      :error="!testPhone(item.id)"
                      type="tel"
                    ></v-text-field>
                    <div
                      v-if="!testPhone(item.id)"
                      class="v-text-field__details"
                    >
                      <div
                        class="v-messages theme--light error--text"
                        role="alert"
                      >
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                            O telefone parece ser inválido.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type === 'email'" style="width: 100%">
                    <v-text-field
                      @input="checkAllForm()"
                      :placeholder="item.title"
                      v-model="form[item.id]"
                      type="email"
                      :error="!testEmail(item.id)"
                    ></v-text-field>
                    <div
                      v-if="!testEmail(item.id)"
                      class="v-text-field__details"
                    >
                      <div
                        class="v-messages theme--light error--text"
                        role="alert"
                      >
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                            O e-mail parece ser inválido.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type === 'daymonth'" style="width: 100%">
                    <v-text-field
                      @input="checkAllForm()"
                      placeholder="31/12"
                      v-model="form[item.id]"
                      v-mask="'##/##'"
                      type="tel"
                      :error="!testDayMonth(item.id)"
                    ></v-text-field>
                    <div
                      v-if="!testDayMonth(item.id)"
                      class="v-text-field__details"
                    >
                      <div
                        class="v-messages theme--light error--text"
                        role="alert"
                      >
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                            Data inválida.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type === 'cpf'" style="width: 100%">
                    <v-text-field
                      @input="checkAllForm()"
                      placeholder="CPF"
                      v-model="form[item.id]"
                      v-mask="'###.###.###-##'"
                      :error="!testCPF(item.id)"
                      type="tel"
                    ></v-text-field>
                    <div v-if="!testCPF(item.id)" class="v-text-field__details">
                      <div
                        class="v-messages theme--light error--text"
                        role="alert"
                      >
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                            Este CPF parece ser inválido.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type === 'cnpj'" style="width: 100%">
                    <v-text-field
                      @input="checkAllForm()"
                      placeholder="CNPJ"
                      v-model="form[item.id]"
                      v-mask="'##.###.###/####-##'"
                      :error="!testCNPJ(item.id)"
                      type="tel"
                    ></v-text-field>
                    <div
                      v-if="!testCNPJ(item.id)"
                      class="v-text-field__details"
                    >
                      <div
                        class="v-messages theme--light error--text"
                        role="alert"
                      >
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                            Este CNPJ parece ser inválido.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-form>

              <div class="my-10 small-text">
                <v-checkbox
                  class="small-text"
                  v-model="form.acept"
                  :ripple="false"
                  @click="checkAllForm()"
                >
                  <template v-slot:label>
                    <span
                      >Li e aceito a
                      <b @click="privacyDialog = true"
                        >Política de Privacidade</b
                      >
                      e os
                      <b @click="termsDialog = true">Termos de Uso</b></span
                    >
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-if="!anonymously"
                  :label="
                    'Permito que o ' +
                      data.store_data.name +
                      ' tenha acesso às minhas informações de contato para o retorno'
                  "
                  class="small-text"
                  v-model="form.lgpd"
                  :ripple="false"
                ></v-checkbox>
                <v-checkbox
                  v-if="!anonymously && !this.queryString.noCache"
                  label="Desejo manter os dados da sessão"
                  class="small-text"
                  v-model="form.saveSession"
                  :ripple="false"
                ></v-checkbox>
              </div>

              <div style="width: 100%" class="text-center">
                <v-btn
                  v-if="form.acept && formMandatoryFieldsComplete"
                  rounded
                  depressed
                  color="primary"
                  dark
                  large
                  class="mt-10 px-10"
                  @click="preventSend()"
                >
                  <h2><b>Finalizar</b></h2>
                </v-btn>
                <br />
                <img src="@/assets/logo1.png" height="32px" class="my-5" />
              </div>
            </v-container>
          </v-card>

          <v-fade-transition>
            <v-card
              tile
              flat
              width="100%"
              class="fill-height ma-0"
              color="primary"
              v-if="state === 3"
            >
              <v-img
                src="@/assets/sucesso.png"
                min-width="100%"
                max-width="600px"
                max-height="100vh"
                min-height="100%"
              >
                <v-row align="center" justify="center" class="fill-height ma-0">
                  <v-col class="text-center">
                    <ClientImage
                      :img="store.icon"
                      :imgSize="store.image_size.toString()"
                    />
                    <h1 class="text-center" style="color:white">
                      <b>Sucesso!</b>
                    </h1>
                    <p style="color:white">
                      {{ text.sucesso | formatName(data.store_data.name) }}
                    </p>
                  </v-col>
                </v-row>
              </v-img>
            </v-card>
          </v-fade-transition>

          <div v-if="state === 4">
            <Roleta
              :color="color"
              :bhash="bhash"
              v-model="state"
              :label="text"
            />
          </div>
        </v-main>

        <v-dialog v-model="privacyDialog" fullscreen>
          <v-card flat class="pa-5">
            <v-app-bar
              flat
              app
              color="white"
              width="100%"
              class="mx-auto text-right"
            >
              <v-icon @click="privacyDialog = false">mdi-close</v-icon>
            </v-app-bar>
            <v-main class="fill-height">
              <v-container>
                <v-divider class="mb-5"></v-divider>
                <Politic />
              </v-container>
            </v-main>
          </v-card>
        </v-dialog>

        <v-dialog v-model="termsDialog" fullscreen>
          <v-card flat class="pa-5">
            <v-app-bar
              flat
              app
              color="white"
              width="100%"
              class="mx-auto text-right"
            >
              <v-icon @click="termsDialog = false">mdi-close</v-icon>
            </v-app-bar>
            <v-main class="fill-height">
              <v-container>
                <v-divider class="mb-5"></v-divider>
                <Terms />
              </v-container>
            </v-main>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog">
          <template>
            <v-card class="pa-5 text-center">
              <p v-html="text.mensagem_faltam_dados_pro_kasino"></p>
              <v-row v-if="!form.lgpd">
                <v-col cols="12">
                  <v-card
                    flat
                    color="primary"
                    dark
                    @click="accept(formCompletionStatus)"
                    class="pa-1 fill-height rounded-xl"
                    v-html="
                      !formCompletionStatus
                        ? text.precisa_terminar_preencher_dados
                        : text.aceitar_compartilhar_dados
                    "
                    ><small v-if="!formCompletionStatus"></small
                  ></v-card>
                </v-col>
              </v-row>
              <v-row v-if="form.lgpd && !formCompletionStatus">
                <v-col cols="12">
                  <v-card
                    flat
                    color="primary"
                    dark
                    @click="dialog = false"
                    class="pa-1 fill-height rounded-xl"
                    v-html="text.terminar_preencher_dados"
                  ></v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card
                    outlined
                    color="white"
                    dark
                    @click="send(true, true)"
                    class="pa-1 fill-height rounded-xl"
                    :style="
                      `color:${color} !important; border:1px solid ${color} !important;`
                    "
                    v-html="text.nao_quero_ganhar"
                  ></v-card>
                </v-col>
              </v-row>
            </v-card>
          </template>
        </v-dialog>

        <v-dialog v-model="dialogResult">
          <template>
            <v-card class="pa-5 text-center">
              <h3 v-if="code" class="mb-5">Você tem um prêmio pendente!</h3>
              <h2 class="mb-5">
                <b>{{ title }}</b>
              </h2>
              <p class="mb-5">{{ text.mensagem_fale_com_o_atendente }}</p>
              <div
                class="py-5 text-center finalcode my-5"
                :style="`border: 2px solid ${color}; color:  ${color};`"
              >
                {{ code }}
              </div>
              <p class="mb-5">{{ text.mensagem_enviamos_por_email }}</p>
              <v-btn
                rounded
                large
                color="primary"
                depressed
                @click="endResult()"
                block
              >
                Beleza!
              </v-btn>
            </v-card>
          </template>
        </v-dialog>

        <div
          style="width:0px !important; height:0px  !important; overflow:hidden;"
        >
          <img src="@/assets/emojis/1.png" />
          <img
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=01.png`"
          />
          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=01.png`
            "
          />
          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=01-preenchido.png`
            "
          />
          <img src="@/assets/emojis/2.png" />
          <img
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=02.png`"
          />

          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=02.png`
            "
          />
          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=02-preenchido.png`
            "
          />
          <img src="@/assets/emojis/3.png" />
          <img
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=03.png`"
          />

          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=03.png`
            "
          />
          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=03-preenchido.png`
            "
          />
          <img src="@/assets/emojis/4.png" />
          <img
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=04.png`"
          />

          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=04.png`
            "
          />
          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=04-preenchido.png`
            "
          />

          <img
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=05.png`"
          />
          <img
            :src="
              `https://comenta.ai/assets/tint.php?hex=${calcColor}&image=05-preenchido.png`
            "
          />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import axios from "axios";
import Barra from "@/components/Barra.vue";
import Roleta from "@/components/Roleta.vue";
import BemVindo from "@/components/BemVindo.vue";
import ClientImage from "@/components/ClientImage.vue";
import Emojis from "@/components/Emojis.vue";
import Emojis2 from "@/components/Emojis2.vue";
import EmojiTitle from "@/components/EmojiTitle.vue";
import Terms from "@/components/Terms.vue";
import Politic from "@/components/Politic.vue";
import { mask } from "vue-the-mask";

// import json from '@/assets/text.json' // Aqui

export default {
  components: {
    Barra,
    BemVindo,
    ClientImage,
    Emojis,
    Emojis2,
    EmojiTitle,
    Roleta,
    Terms,
    Politic,
  },
  computed: {
    categories() {
      return this.data.categories;
    },
    selectors() {
      return this.data.selectors;
    },
    ordenator() {
      return this.data.ordenator;
    },
    optionals() {
      return this.data.optionals;
    },
    calcComplete() {
      let pc = this.getPC();
      let nonOptionals = this.calcNonOptionals();
      if (nonOptionals === 0) return 50;
      let totEmoji = 0;
      for (let r = 0; r < this.emojis.length; r++) {
        if (
          typeof this.emojis[r] !== "undefined" &&
          typeof this.emojis[r].value !== "undefined"
        ) {
          totEmoji++;
        }
      }
      let selecteds = 0;
      for (let hm = 0; hm < this.selected.length; hm++) {
        if (
          typeof this.selected[hm] !== "undefined" &&
          this.selected[hm] !== ""
        ) {
          selecteds++;
        }
      }

      let media = ((totEmoji + selecteds) * pc) / nonOptionals;
      if (media > 50) media = 50;
      return media;
    },
    calcMedia() {
      if (this.emojis.length === 0) {
        this.updateMedia(10);
        return 10;
      }
      let nonOptionalsEmojis = this.calcNonOptionalsEmojis();
      if (nonOptionalsEmojis === 0) return 50;
      let media = 0;
      let i = 0;
      while (i < nonOptionalsEmojis) {
        if (
          typeof this.emojis[i] !== "undefined" &&
          typeof this.emojis[i].value !== "undefined"
        ) {
          const v = this.emojis[i].value;
          media += v;
        } else {
          media += 5;
        }
        i++;
      }
      const result = (media * 2) / nonOptionalsEmojis;
      this.updateMedia(result);
      return result;
    },
    checkForm() {
      let isValid = true;
      for (let m = 0; m < this.formFields.length; m++) {
        if (this.formFields[m].mandatory) {
          if (
            this.formFields[m].type === "cpf" &&
            (typeof this.form[this.formFields[m].id] === "undefined" ||
              (!!this.form[this.formFields[m].id] &&
                !this.validarCPF(this.form[this.formFields[m].id])))
          ) {
            isValid = false;
          }
          if (
            this.formFields[m].type === "cnpj" &&
            (typeof this.form[this.formFields[m].id] === "undefined" ||
              (!!this.form[this.formFields[m].id] &&
                !this.validarCNPJ(this.form[this.formFields[m].id])))
          ) {
            isValid = false;
          }
          if (
            this.formFields[m].type === "phone" &&
            (typeof this.form[this.formFields[m].id] === "undefined" ||
              (!!this.form[this.formFields[m].id] &&
                !this.validaPhone(this.form[this.formFields[m].id])))
          ) {
            isValid = false;
          }
          if (
            this.formFields[m].type === "daymonth" &&
            (typeof this.form[this.formFields[m].id] === "undefined" ||
              (!!this.form[this.formFields[m].id] &&
                !this.validaData(this.form[this.formFields[m].id])))
          ) {
            isValid = false;
          }
          if (
            this.formFields[m].id === "1" &&
            this.form[this.formFields[m].id] + "" === ""
          ) {
            isValid = false;
          }
        }
      }
      return isValid;
    },
    allForm() {
      let status = true;
      for (let m = 0; m < this.formFields.length; m++) {
        if (
          typeof this.form[this.formFields[m].id] !== "undefined" &&
          this.form[this.formFields[m].id] + "" === ""
        )
          status = false;
      }
      return status;
    },
    checkDisabled() {
      let pc = this.getPC();
      let nonOptionals = this.calcNonOptionals();
      if (nonOptionals === 0) return true;
      let selecteds = 0;
      for (let hm = 0; hm < this.selected.length; hm++) {
        if (
          typeof this.selected[hm] !== "undefined" &&
          this.selected[hm] !== ""
        ) {
          selecteds++;
        }
      }
      let pper = this.store.perguntas_personalizadas;
      for (let m = 0; m < pper.length; m++) {
        if (
          typeof this.form[pper[m].id] !== "undefined" &&
          this.form[pper[m].id] + "" === ""
        ) {
          selecteds++;
        }
      }
      let media = ((this.emojis.length + selecteds) * pc) / nonOptionals;
      return media >= 50;
    },
    calcColor() {
      return this.color.replace("#", "");
    },
    cpfCheck(id) {
      return !this.cpfTest(this.form[id]) ? "CPF Inválido" : false;
    },
    cnpjCheck(id) {
      return !this.cnpjTest(this.form[id]) ? "CPF Inválido" : false;
    },
    emailCheck(id) {
      return !this.emailTest(this.form[id])
        ? "E-mail precisa ser válido"
        : false;
    },
  },
  watch: {
    color() {
      this.$vuetify.theme.themes.light.primary = this.color;
      this.$vuetify.theme.themes.dark.primary = this.color;
      const favicon = document.getElementById("favicon");
      favicon.href =
        "https://comenta.ai/assets/tint.php?hex=" +
        this.color.replace("#", "") +
        "&image=04.png";
    },
    state() {
      window.scrollTo(0, 0);
      if (this.state === 3 && this.callback) {
        setTimeout(() => {
          window.location = this.callback;
        }, 2000);
      }
    },
  },
  directives: { mask },
  data: () => ({
    termsDialog: false,
    privacyDialog: false,
    dialogResult: false,
    isPendingSend: false,
    state: 0,
    rota: "",
    queryString: [],
    data: {},
    emojis: [],
    optemojis: [],
    selected: [],
    selectedButNotAccounted: [],
    result: [],
    form: {},
    formFields: [],
    loading: false,
    uuid: "",
    zoom: 50,
    text: {},
    disabled: true,
    dateRules: [
      (v) =>
        !!v ||
        typeof v === "undefined" ||
        v === "" ||
        (v.length === 5 &&
          v.split("/")[0] * 1 < 32 &&
          v.split("/")[1] * 1 < 13) ||
        "O dia de aniversário não é válido",
    ],
    phoneRules: [
      (v) =>
        !!v ||
        typeof v === "undefined" ||
        v === "" ||
        v.length === 15 ||
        "O número de telefone precisa ser válido",
    ],
    cpfRules: [
      (v) =>
        !!v ||
        typeof v === "undefined" ||
        v === "" ||
        this.validarCPF(v) ||
        "O CPF parece ser inválido",
    ],
    cnpjRules: [
      (v) =>
        !!v ||
        typeof v === "undefined" ||
        v === "" ||
        this.validarCNPJ(v) ||
        "O CNPJ parece ser inválido",
    ],
    emailRules: [
      (v) =>
        !!v ||
        typeof v === "undefined" ||
        v === "" ||
        this.emailTest(v) ||
        "O E-mail parece ser inválido",
    ],
    atendente: false,
    atendenteInput: null,
    color: "#FFFFFF",
    formCompletionStatus: false,
    formMandatoryFieldsComplete: false,
    atendant_denomination: "atendente",
    store: {},
    atendenteEmojis: 0,
    emojiEnabled: [],
    questionEnable: [],
    resposta_personalizadas: [],
    selections: [],
    multipleQuestions: [],
    bhash: "",
    dialog: "",
    error: false,
    callback: null,
    code: "",
    title: "",
    noObligatoryField: true,
    anonymously: false,
    valid: false,
  }),
  methods: {
    onLoad() {
      this.loading = true;
      this.rota = this.$route.params.name;
      this.queryString = this.$route.query;
      if (!this.rota) {
        return false;
      }
      const d = new Date();
      this.uuid =
        d.getTime() +
        "_" +
        Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, "")
          .substr(0, 10);
      axios.get(
        `https://comenta.ai/pingback/${this.rota}/${this.uuid}/start`
      );
      let phone = "";
      if (this.$route.params.phone) {
        phone = `/${this.$route.params.phone}`;
        this.form.phone = this.$route.params.phone;
      }
      const url = `https://comenta.ai/perguntas/${this.rota}${phone}`;

      return axios
        .get(url)
        .then((res) => {
          this.store = res.data.store_data;
          this.text.nota = this.store.comentai_general_text;
          this.text.comentario = this.store.comentai_comment_text;
          this.text.sucesso = this.store.comentai_end_text;
          if (this.store.store_color) {
            this.color = this.store.store_color;
            this.atendant_denomination = this.store.atendant_denomination;
            this.formFields = this.store.form;
            for (let i = 0; i < this.formFields.length; i++) {
              if (this.formFields[i].mandatory) this.noObligatoryField = false;
            }
            this.$vuetify.theme.themes.light.primary = this.color;
            this.$vuetify.theme.themes.dark.primary = this.color;
          } else {
            this.color = "#FF3366";
            this.$vuetify.theme.themes.light.primary = this.color;
            this.$vuetify.theme.themes.dark.primary = this.color;
          }

          if (this.store.callback_url) {
            this.callback = this.store.callback_url;
          }

          this.data = res.data;

          const storage = localStorage.getItem("object");
          if (storage) {
            const user = JSON.parse(storage);
            if (this.anonymously) {
              user.allow_show_contact = false;
              user.saveSession = false;
            }
            for (let m = 0; m < this.formFields.length; m++) {
              this.form[this.formFields[m].id] =
                user["field_" + this.formFields[m].id];
            }
            this.form.lgpd = user.allow_show_contact;
            this.form.saveSession = user.saveSession;
          } else if (this.queryString.clientName) {
            this.form["1"] = this.queryString.clientName;
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        })
        .catch((err) => {
          window.location.href = "https://comenta.ai";
          console.log(err);
        });
    },
    loadText() {
      axios
        .get("https://comenta.ai/getconfigs")
        .then((res) => {
          this.text = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getColor(item) {
      const check = this.includes(item);
      if (check.included) {
        return "primary";
      }
      return "gray";
    },
    addMotive(item,question) {
      const check = this.includes(item);
      let index = check.index;
      if (check.included) {
        this.selections.splice(index, 1);
      } else {
        this.selections.push(item);
      }
      if(this.selections.length>0){
        this.multipleQuestions["selector_"+question] = question;
      } else {
        this.multipleQuestions = this.multipleQuestions.filter( item => item !== "selector_"+question );
      }
    },
    includes(item) {
      let included = false;
      let index = 0;
      for (let i = 0; i < this.selections.length; i++) {
        const element = this.selections[i];
        if (item.id === element.id) {
          included = true;
          index = i;
        }
      }
      return { included: included, index: index };
    },
    forceFormCheck() {
      let status = true;
      for (let m = 0; m < this.formFields.length; m++) {
        if (
          typeof this.form[this.formFields[m].id] !== "undefined" &&
          this.form[this.formFields[m].id] + "" === ""
        )
          status = false;
      }
      return status;
    },
    checkAllForm() {
      let status = true;
      for (let m = 0; m < this.formFields.length; m++) {
        if (
          this.formFields[m].mandatory &&
          (typeof this.form[this.formFields[m].id] === "undefined" ||
            this.form[this.formFields[m].id] + "" === "")
        )
          status = false;
        if (
          this.formFields[m].type === "cpf" &&
          !this.testCPF(this.formFields[m].id)
        )
          status = false;
        if (
          this.formFields[m].type === "cnpj" &&
          !this.testCNPJ(this.formFields[m].id)
        )
          status = false;
        if (
          this.formFields[m].type === "daymonth" &&
          !this.testDayMonth(this.formFields[m].id)
        )
          status = false;
        if (
          this.formFields[m].type === "email" &&
          !this.testEmail(this.formFields[m].id)
        )
          status = false;
        if (
          this.formFields[m].type === "phone" &&
          !this.testPhone(this.formFields[m].id)
        )
          status = false;
      }
      if (!this.form.acept) {
        status = this.form.acept;
      }
      this.formMandatoryFieldsComplete = status;
      this.checkEntireForm();
      return status;
    },
    checkEntireForm() {
      let allFormStatus = true;
      for (let m = 0; m < this.formFields.length; m++) {
        if (
          typeof this.form[this.formFields[m].id] === "undefined" ||
          this.form[this.formFields[m].id] + "" === ""
        )
          allFormStatus = false;
      }
      this.formCompletionStatus = allFormStatus;
    },
    send(type, cancelLucky = false) {
      this.dialog = false;
      if (
        this.store.premia === 1 &&
        (!this.form.lgpd || !this.forceFormCheck()) &&
        !type
      ) {
        this.dialog = true;
        return false;
      }
      axios.get(
        `https://comenta.ai/pingback/${this.rota}/${this.uuid}/complete`
      );
      if (type) {
        let isValid = true;
        for (let m = 0; m < this.formFields.length; m++) {
          if (
            this.formFields[m].mandatory &&
            !!this.form[this.formFields[m].id] &&
            this.form[this.formFields[m].id] === ""
          ) {
            isValid = false;
          }
        }
        if (!isValid) {
          return false;
        }
      }

      this.disabled = false;
      this.zoom = 100;
      const object = {};
      const reasons = [];
      let selectorId = null;

      if(typeof this.selectors!='undefined') for (let i = 0; i < this.selectors.length; i++) {
        selectorId = this.selectors[i].id;
        object["selector_" + selectorId] = this.selected[i];
      }

      object.selectionsOnMultiple = this.selections;
      
      for(let key in this.multipleQuestions){
        object[key] = key;
      }

      for (let i = 0; i < this.emojis.length; i++) {
        const element = this.emojis[i];
        if (
          typeof element !== "undefined" &&
          typeof element.id !== "undefined"
        ) {
          object["eval_" + element.id] = element.value;

          for (let j = 0; j < element.motive.length; j++) {
            const motive = element.motive[j];
            reasons.push(motive.id);
          }
        }
      }

      for (let i = 0; i < this.optemojis.length; i++) {
        const element = this.optemojis[i];
        if (
          typeof element !== "undefined" &&
          typeof element.id !== "undefined"
        ) {
          object["eval_" + element.id] = element.value;

          for (let j = 0; j < element.motive.length; j++) {
            const motive = element.motive[j];
            reasons.push(motive.id);
          }
        }
      }

      object.cf = [];
      for (var [key, value] of Object.entries(this.queryString)) {
        object.cf[key] = value;
      }

      if (this.queryString.uid) {
        object.uid = this.queryString.uid;
      }
      object.reasons = reasons.join(".");
      object.general = this.form.media;
      object.evaluation_details = this.form.comment;
      object.attendant = this.form.attendant;
      object.attendant_id = this.form.attendant_id;
      if (
        typeof this.form.attendant_eval != "undefined" &&
        typeof this.form.attendant_eval.value != "undefined"
      ) {
        object.attendant_eval = this.form.attendant_eval.value;
      }

      object.attendant_obs = this.form.attendant_obs;

      object.formdata = [];
      let localStorageDataFields = {};
      if (type) {
        for (let m = 0; m < this.formFields.length; m++) {
          object.formdata["field_" + this.formFields[m].id] = this.form[
            this.formFields[m].id
          ];
          localStorageDataFields["field_" + this.formFields[m].id] = this.form[
            this.formFields[m].id
          ];
        }
        object.allow_show_contact = this.form.lgpd;
        localStorageDataFields.allow_show_contact = this.form.lgpd;
        localStorageDataFields.saveSession = this.form.saveSession;
      }
      if (this.store.perguntas_personalizadas) {
        object.perguntas_personalizadas = [];
        for (let i = 0; i < this.store.perguntas_personalizadas.length; i++) {
          if (this.resposta_personalizadas[i]) {
            object.perguntas_personalizadas.push({
              pergunta: this.store.perguntas_personalizadas[i].pergunta,
              resposta: this.resposta_personalizadas[i],
            });
          }
        }
      }
      if (this.isPendingSend) return false;
      this.isPendingSend = true;
      const url =
        "https://comenta.ai/evaluate/registerEvaluation/" +
        this.rota +
        (this.data.user.user_phone ? "/" + this.data.user.user_phone : "");

      var qs = require("qs");
      if (this.form.saveSession) {
        localStorage.setItem("object", JSON.stringify(localStorageDataFields));
      } else {
        localStorage.clear();
      }
      delete object.saveSession;

      axios
        .post(url, qs.stringify(object))
        .then((res) => {
          if (!res.data.bhash) {
            return (this.state = 3);
          }
          if (cancelLucky) {
            this.state = 3;
          } else if (
            res.data.bhash &&
            this.store.premia === 1 &&
            this.form.lgpd &&
            this.forceFormCheck()
          ) {
            this.bhash = res.data.bhash;
            if (res.data.code && res.data.title) {
              this.code = res.data.code;
              this.title = res.data.title;
              this.dialogResult = true;
            } else {
              this.state = 4;
            }
          } else {
            this.state = 3;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getformFields() {
      return this.formFields;
    },
    testCPF(id) {
      return (
        typeof this.form[id] === "undefined" ||
        this.form[id] === "" ||
        this.cpfTest(this.form[id])
      );
    },
    testCNPJ(id) {
      return (
        typeof this.form[id] === "undefined" ||
        this.form[id] === "" ||
        this.cnpjTest(this.form[id])
      );
    },
    testEmail(id) {
      return (
        typeof this.form[id] === "undefined" ||
        this.form[id] === "" ||
        this.emailTest(this.form[id])
      );
    },
    testPhone(id) {
      return (
        typeof this.form[id] === "undefined" ||
        this.form[id] === "" ||
        (!!this.form[id] &&
          (this.form[id].length === 15 || this.form[id].length === 15))
      );
    },
    testDayMonth(id) {
      return (
        typeof this.form[id] === "undefined" ||
        ((this.form[id] === "" ||
          (this.form[id].length === 5 &&
            this.form[id].split("/")[0] * 1 < 32)) &&
          this.form[id].split("/")[1] * 1 < 13)
      );
    },
    getPC() {
      return 50;
    },
    isObject(item) {
      return typeof item === "object" && item !== null;
    },
    calcNonOptionals() {
      let nonOptionals = 0;
      for (let tq = 0; tq < this.categories.length; tq++) {
        if (
          typeof this.categories[tq] !== "undefined" &&
          typeof this.categories[tq].id !== "undefined" &&
          !!this.categories[tq].id &&
          this.categories[tq].optional == 0 &&
          !this.inArray(this.categories[tq].id + "", this.optionals.questions)
        ) {
          nonOptionals++;
        }
      }
      if(typeof this.selectors!='undefined') for (let tq = 0; tq < this.selectors.length; tq++) {
        if (
          typeof this.selectors[tq] !== "undefined" &&
          typeof this.selectors[tq].id !== "undefined" &&
          this.selectors[tq].optional == 0 &&
          this.selectors[tq].options.length > 0 &&
          !this.inArray(this.selectors[tq].id + "", this.optionals.options)
        ) {
          nonOptionals++;
        }
      }
      let pper = this.store.perguntas_personalizadas;
      for (let m = 0; m < pper.length; m++) {
        if (
          typeof pper[m].optional !== "undefined" &&
          pper[m].optional == 0 &&
          this.inArray("t" + pper[m].id, this.ordenator) &&
          (this.resposta_personalizadas[m] == "" ||
            typeof this.resposta_personalizadas[m] == "undefined")
        ) {
          nonOptionals++;
        }
      }
      console.log("nonOptionals", nonOptionals);
      return nonOptionals;
    },
    calcNonOptionalsEmojis() {
      let nonOptionals = 0;
      for (let tq = 0; tq < this.categories.length; tq++) {
        if (
          typeof this.categories[tq] !== "undefined" &&
          typeof this.categories[tq].id !== "undefined" &&
          !!this.categories[tq].id &&
          this.categories[tq].optional == 0 &&
          !this.inArray(this.categories[tq].id + "", this.optionals.questions)
        ) {
          nonOptionals++;
        }
      }
      return nonOptionals;
    },
    inArray(needle, haystack) {
      if (typeof needle === "undefined" || typeof haystack === "undefined")
        return false;
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    updateMedia(value) {
      this.form.media = value;
    },
    validUser(user) {
      if (!user.user_phone) {
        return;
      }
    },
    changeState(item) {
      axios.get(
        `https://comenta.ai/pingback/${this.rota}/${this.uuid}/evaluation_done`
      );
      if (
        this.data.user.user_phone &&
        (!this.store.premia || this.store.premia === 0)
      ) {
        this.form.phone = this.data.user.user_phone;
        this.send(false);
      } else {
        this.state = item;
      }
    },
    validarCPF(cpf) {
      if (typeof cpf === "undefined") return true;
      cpf = cpf.replace(/[^\d]+/g, "");
      if (
        cpf.length != 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
      ) {
        return false;
      }
      var Soma;
      var Resto;
      Soma = 0;
      if (cpf == "00000000000") return false;
      for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(9, 10))) return false;
      Soma = 0;
      for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(10, 11))) return false;
      return true;
    },
    validarCNPJ(cnpj) {
      if (typeof cnpj === "undefined") return true;
      cnpj = cnpj.replace(/[^\d]+/g, "");
      if (cnpj == "") return false;
      if (cnpj.length != 14) return false;
      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999"
      )
        return false;
      // Valida DVs
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(1)) return false;
      return true;
    },
    validaData(v) {
      return (
        !!v ||
        typeof v === "undefined" ||
        ((v === "" || (v.length === 5 && v.split("/")[0] * 1 < 32)) &&
          v.split("/")[1] * 1 < 13)
      );
    },
    validaPhone(v) {
      return !!v && v.length === 15;
    },
    preventSend() {
      if (this.store.premia === 1) {
        let isValid = true;
        for (let m = 0; m < this.formFields.length; m++) {
          if (
            typeof this.form[this.formFields[m].id] === "undefined" ||
            this.form[this.formFields[m].id] === ""
          )
            isValid = false;
        }
        if (isValid && this.form.lgpd) {
          this.send(true);
        } else {
          this.dialog = true;
        }
      } else {
        this.send(true);
      }
    },
    accept(send) {
      this.form.lgpd = true;
      if (send) {
        this.send(true);
      } else {
        this.dialog = false;
      }
    },
    endResult() {
      this.dialogResult = false;
      this.state = 3;
    },
    cpfTest(strCPF) {
      if (!strCPF) {
        return true;
      }
      strCPF = strCPF.replace(/[.]/g, "");
      strCPF = strCPF.replace("-", "");
      if (
        strCPF.length != 11 ||
        strCPF === "00000000000" ||
        strCPF === "11111111111" ||
        strCPF === "22222222222" ||
        strCPF === "33333333333" ||
        strCPF === "44444444444" ||
        strCPF === "55555555555" ||
        strCPF === "66666666666" ||
        strCPF === "77777777777" ||
        strCPF === "88888888888" ||
        strCPF === "99999999999"
      ) {
        return false;
      }
      let Soma;
      let Resto;
      Soma = 0;

      if (strCPF == "00000000000") return false;

      for (let i = 1; i <= 9; i++) {
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      }
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++) {
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      }
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },
    emailTest(email) {
      if (!email || typeof email === "undefined") {
        return true;
      }
      let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
  },
  created() {
    this.onLoad();
    this.loadText();
  },
};
</script>

<style>
.small-text .v-label {
  font-size: 12px !important;
}

.text-secondary {
  color: #4c4c4c;
}

.v-slider {
  transition: none !important;
}

.v-slider__track-container {
  height: 8px !important;
  border-radius: 4px !important;
  overflow: hidden;
}

.v-slider__thumb:before {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  content: "";
  color: inherit;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: transparent !important;
  opacity: 0.3;
  position: absolute;
  left: -50%;
  top: -50%;
  transform: scale(0.1);
  pointer-events: none;
}

.v-slider__thumb:after {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  content: "";
  color: inherit;
  width: 250%;
  height: 250%;
  border-radius: 50%;
  background: inherit !important;
  position: absolute;
  left: -75%;
  top: -75%;
}

.v-slider__thumb-label-container {
  margin-top: -5px;
}
.v-slider__thumb-label {
  font-size: 1rem !important;
}
.v-application .my-10 {
  margin-bottom: 0 !important;
}

.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  font-size: 0.8em;
}

.x-small-text {
  font-size: 10px;
}
.v-chip .v-avatar {
  height: 60px !important;
  width: 60px !important;
  border-radius: 0;
}
.v-avatar img,
.v-avatar svg,
.v-avatar .v-icon,
.v-avatar .v-image,
.v-avatar .v-responsive__content {
  height: 40px;
  width: 40px;
}
.v-dialog .v-chip{
  min-height: 60px;
  max-width: 80%;
  line-height: 22px;
  line-break: auto;
  white-space: break-spaces;
}
.theme--light.v-chip:not(.v-chip--active) {
  background: #fff;
  height: 60px;
}

.v-chip.v-size--default {
  font-size: 18px;
  height: 60px;
}
.v-application--is-ltr .v-list-item__avatar:first-child {
  margin-right: 16px;
  width: 60px !important;
  height: 60px !important;
}
</style>
<!-- 
.v-image__image--cover {
    background-size: cover;
    width: 60px;
    height: 60px;
} -->
